import { Button, Grid, Typography } from '@mui/material'
import { useDispatch } from 'react-redux';
import { getNextInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import { useNavigate } from 'react-router-dom';

const DebtCard = ({ price }: { price: number }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return (
        <Grid container sx={{ alignItems: "center", border: "1px solid #D7DBEC", borderRadius: "5px", background: "#FBE4E7", padding: "10px 20px", minHeight: "75px" }}>
            <Grid item xs={7} sx={{ display: "flex", flexDirection: "column" }}>
                <Grid item>
                    <Typography sx={{ fontSize: "0.875rem" }}>
                        مبلغ بدهی
                        (ریال)
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold", letterSpacing: "1px" }}>
                        {price.toLocaleString('fa')}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item xs={5}>
                <Button sx={{ height: "40px", fontWeight: "bold" }} fullWidth className='bgPrimaryErrorColorLight witheColor hover:!bg-[#FF617C]' onClick={() => navigate('/loans/installments/FutureLoans')} type='button' >
                    مشاهده و پرداخت
                </Button>
            </Grid>
        </Grid>
    )
}

export default DebtCard
